import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PORTAL_ROUTE_NAMES } from '@app/modules/portal/portal.routes.names';
import { ContactService } from '@app/core/services/contact/contact.service';

@Component({
  selector: 'app-assisted-mode-dialog',
  templateUrl: './assisted-mode-dialog.component.html',
  styleUrls: ['./assisted-mode-dialog.component.scss'],
})
export class AssistedModeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AssistedModeDialogComponent>,
    public contactService: ContactService
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  get trackRequestsLink() {
    return `/${PORTAL_ROUTE_NAMES.TRACK_REQUESTS}`;
  }
}
